import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const idMe = defineConnector({
  identifier: "idMe",
  name: "ID.me",
  tagLine: "Identity verification APIs",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api\\.id\\.me/.*",
  auth: (app) =>
    queryAuth([{ name: "access_token", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Create an OAuth 2.0 access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://docs.id.me/guides/o-auth-2-0/overview](https://docs.id.me/guides/o-auth-2-0/overview) to create an OAuth 2.0 access token for the ID.me API. The protected resource example includes that token in the request as `access_token`.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "OAuth 2.0 access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.id.me/api/public/v3/attributes.json",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url:
        testUrl ?? (() => "https://api.id.me/api/public/v3/attributes.json")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
